const ThirdPartyPhoneAccountConfig = () =>
  import('@/views/main/thirdPartyPhoneAccountConfig/ThirdPartyPhoneAccountConfig.vue')

export default {
  path: '/main/thirdPartyPhoneAccountConfig',
  name: 'ThirdPartyPhoneAccountConfig',
  component: ThirdPartyPhoneAccountConfig
}
